/** @format */

export const services = [
  {
    id: 1,
    name: "frontend",
    items: [
      {
        text: "Create single page web app.",
      },
      {
        text: "Develop the user interface.",
      },
      {
        text: "Create animated websites.",
      },
      {
        text: "Create responsive web app's.",
      },
    ],
  },
  {
    id: 2,
    name: "backend",
    items: [
      {
        text: "Create RESTFULL API's. using Express & Nest Js",
      },
      {
        text: "Integrate NoSQL & SQL database using ORM's",
      },
      {
        text: "Deploy application's to docker and AWS.",
      },
      {
        text: "Add Socket.io for real time chat apps.",
      },
      {
        text: "Integrate OAUTH using 3rd party apps.",
      },
    ],
  },
  {
    id: 3,
    name: "other",
    items: [
      {
        text: "Edit photos.",
      },
      {
        text: "Create UI for web pages.",
      },
      {
        text: "Create posters.",
      },
      {
        text: "Edit Videos.",
      },
    ],
  },
];
